module.exports = __webpack_public_path__ + "img/InspectionCompleteMajor2.8afdda08.png";